// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__YnCcj","image":"style_image__19-4a"};